//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
let d=[[[0,"EditorLevel",1,0],[0,"GeometrySize",1,0],[0,"MaterialName",1,0],[0,"ModelGeometry",1,0],[0,"ThumbnailPreview",1,0]],[],[]];
SPLM.Display.VisualMaterialEditorSettingsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.VisualMaterialEditorSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.VisualMaterialEditorSettingsBuilder.ModelGeometryType = Object.freeze({
    "NXShaderBall" : "NXShaderBall", "Sphere" : "Sphere", "Cube" : "Cube", "Cylinder" : "Cylinder", "Plane" : "Plane", "Fabric" : "Fabric", "Speedform" : "Speedform"});

SPLM.Display.VisualMaterialEditorSettingsBuilder.GeometrySizeType = Object.freeze({
    "Small" : "Small", "Medium" : "Medium", "Large" : "Large", "ExtraLarge" : "ExtraLarge"});

SPLM.Display.VisualMaterialEditorSettingsBuilder.EditorLevelType = Object.freeze({
    "Basic" : "Basic", "Intermediate" : "Intermediate", "Full" : "Full"});

export default SPLM;